<div class="mct-flex mct-row mct-justify-between mct-items-stretch">
  <h4>
    {{ 'profiles.view.referral-report.label' | translate | titlecase }}&nbsp;
    <span class="card-field-label">({{ 'profiles.view.referral-report.past-12-months' | translate | titlecase }})</span>
  </h4>
  <a (click)="openAddReferralDialog()"> {{ 'profiles.view.referral-report.add-referral' | translate | titlecase }}</a>
</div>
<div class="referral-report-container">
  <div class="referral-report-chart">
    <p-chart #referralChart type="pie" [data]="chartData" [options]="chartOptions" [height]="136"
      [width]="136"></p-chart>
  </div>
  <div class="referral-report-legend">
    <div class="card-field-label legend-item">{{ totalReferrals }}&nbsp;{{ 'profiles.view.referral-report.total' |
      translate }}</div>
    <div *ngFor="let referral of referralSummary.ReferralCollection; let i = index" class="legend-item">
      <div class="chart-legend-colorbox" [ngStyle]="{ 'background-color': colors[i] }"></div>
      <div class="legend-text">{{ referral.ReferralType }}</div>
    </div>
  </div>
</div>
<div class="report-button mct-flex mct-justify-center">
  <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="navigateToReferralReport()">
    {{ 'profiles.view.referral-report.view-report' | translate | uppercase }}
  </button>
</div>
<wl-add-referral-dialog (referralAdded)="loadData(true)" [profileId]="profileId"></wl-add-referral-dialog>